<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="indexItems"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :indexNested="true"
    :disablePagination="true"
    :containSearchBar="false"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"
  >
  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
// import New from "./new.vue";
// import Edit from "./edit.vue";
// import Delete from "./delete.vue";
// import PlanningOperationShow from "../planning_seed_plot_operations/edit.vue"

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      totalItems: 0,
      tableHeaders: [
        { text: "Código", align: "left", sortable: true, value: "code"},
        { text: "Tipo de Operação", align: "left", sortable: true, value: "operationName"},
        // { text: "Cultura(s)", align: "left", sortable: true, value: "cultureNames"},
        { text: "Insumos", align: "left", sortable: true, value: "varietyNames"},
        { text: "Lotes", align: "left", sortable: true, value: "lots", filter_value: "lotsFilter"},
        { text: "Lotes", align: "left", sortable: true, value: "newLots", filter_value: "newLotsFilter"},        
        // { text: "Lote(qtd. vendida)", align: "left", sortable: false, value: "sown"},
        // { text: "Área Total", align: "left", sortable: true, value: "periodsTotalArea" },
        { text: "Data da Operação", align: "left", sortable: true, value: "operationDate" },
        // { text: "Duração Total", align: "left", sortable: true, value: "activitiesTotalDuration" },
        // { text: "Planejamento", align: "left", sortable: false, value: "link" },
        // { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      // maskFields: [
      //   { field: 'operationDate', mask: 'date'},
      //   { field: 'periodsNamesList', mask: 'tag', color: 'success', outlined: true }, 
      //   { field: 'periodsTotalArea', mask: 'number_unit', unit: 'ha' },
      // ],
      infoHeaders: [
        { field: 'varietyNames', info: 'Variedades, fertilizantes, agrotóxicos e biológicos consumidos nas operações. *Em operações de destinar semeios as variedades indicadas são as geradas.' },
        { field: 'lots', info: 'Lotes semeados, em estufa ou aplicados'},
        { field: 'newLots', info: 'Novo lote'},
      ],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: ["code"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Operação"
    },
    modelNamePlural: {
      type: String,
      default: "Operações"
    },
    indexItems:{
      type: Array,
      default: Array.new,
    }
  },
  components: {
    BaseIndex: BaseIndex,
    // New: New,
    // Edit: Edit,
    // Delete: Delete,
    // PlanningOperationShow: PlanningOperationShow
  },
  created() {
    // console.log("index", this.indexItems);
    this.totalItems = this.indexItems.length;
    // this.loadServerEntries();
  },
  computed: {
    maskFields() {
      return [
        { field: 'operationDate', mask: 'date'},
        ... this.$vuetify.breakpoint.smAndDown ? [] : [{ field: 'periodsNamesList', mask: 'tag', color: 'success', outlined: true }], 
        { field: 'periodsTotalArea', mask: 'number_unit', unit: 'ha' },
      ]
    }
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      // this.loadServerEntries();
    },
    loadServerEntries: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_SEED_PLOT_OPERATIONS,
          variables: {
            input: { //todo index com paginação, ordenação e filtros server-side precisa enviar essas informações quando fizer a busca por dados
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.sortable ? (val.filter_value ? val.filter_value : val.value) : null).filter(val => val != null),
              filters: this.filters
            }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // this.executionOperations = response.data.groundContext.allExecutionOperations;
          // console.log("All executionOperations", response.data.groundContext.executionOperationsIndex);
          this.indexItems = response.data.groundContext.seedPlotOperationsIndex.seedPlotOperationViewIndexFilters; //seta os itens retornados do servidor para o array de itens que será exibido na tabela
          this.totalItems = response.data.groundContext.seedPlotOperationsIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
          this.typeOperators = response.data.groundContext.seedPlotOperationsIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
          this.serverFields = response.data.groundContext.seedPlotOperationsIndex.serverFields; // seta os campos que podem ser filtrados
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      // this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      // this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      // this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    optionsChange: function(opts) {
      this.options = opts;
      // this.loadServerEntries();
    },
  }
};

const LOAD_ALL_SEED_PLOT_OPERATIONS = gql `
  query($input: IndexInputObject!) {
    groundContext {
      seedPlotOperationsIndex(input: $input){
        count
        typeOperators
        serverFields      
        seedPlotOperationViewIndexFilters {
          id
          code
          planningOperationId
          planningOperationCode
          operationDate
          canBeDeleted
          operationName
          varietyNames
          lots
          newLots
          storageNames
          cultureNames
          undeletabilityReasons
        }
      }
    }
  }
`;

</script>

<style scoped></style>
